export const COMMISSION_ACTIONS = {
    COMMISSION_SEARCH: 'COMMISSION_SEARCH',
    COMMISSION_SEARCH_SUCCESS: 'COMMISSION_SEARCH_SUCCESS',
    COMMISSION_SEARCH_ERROR: 'COMMISSION_SEARCH_ERROR',

    COMMISSION_UPSERT: 'COMMISSION_UPSERT',
    COMMISSION_UPSERT_SUCCESS: 'COMMISSION_UPSERT_SUCCESS',
    COMMISSION_UPSERT_ERROR: 'COMMISSION_UPSERT_ERROR',

    COMMISSION_EDIT: 'COMMISSION_EDIT',

    COMMISSION_RESET: 'COMMISSION_RESET',
};

export const commissionResetAction = () => ({
    type: COMMISSION_ACTIONS.COMMISSION_RESET,
});

export const commissionSearchAction = (payload) => ({
    type: COMMISSION_ACTIONS.COMMISSION_SEARCH,
    ...payload,
});

export const commissionEditAction = (payload) => ({
    type: COMMISSION_ACTIONS.COMMISSION_EDIT,
    ...payload,
});

export const commissionUpsertAction = (payload) => ({
    type: COMMISSION_ACTIONS.COMMISSION_UPSERT,
    ...payload,
});

export default {
    COMMISSION_ACTIONS,
    commissionSearchAction,
    commissionUpsertAction,
    commissionEditAction,
};
